import { tv } from 'tailwind-variants'

export const inputStyles = tv({
	base: 'font-apercu-primary',
	slots: {
		container:
			'web:flex h-10 native:h-12 bg-transparent web:focus-visible:outline-none web:focus-visible:ring-2 web:focus-visible:ring-ring web:focus-visible:ring-offset-2 focus:outline-none',
		input:
			'text-palette_3 border-b-2 border-palette_3 font-apercu-primary text-base lg:text-lg px-[.05em] py-[.35em]',
		placeholder: 'font-apercu-bold',
	},
	variants: {
		editable: {
			false: {
				input: 'opacity-50 web:cursor-not-allowed',
			},
		},
	},
})
